import { handleActions, combineActions } from 'redux-actions'

import { expandPanel } from '@tabeeb/modules/sessionTabs/actions'
import { onEnableSelection, onChangePressedButton, onDisposeDrawing, onHideAnnotations } from '../../actions/drawing'
import * as playerToolbarActions from '../../actions'

const defaultState = ''

export default handleActions(
  {
    [onChangePressedButton](state, action) {
      return action.payload.pressedButton
    },
    [combineActions(onDisposeDrawing, expandPanel, onHideAnnotations, onEnableSelection)](state, action) {
      return defaultState
    },
    [playerToolbarActions.resetState](state, action) {
      return defaultState
    },
  },
  defaultState
)
